import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const FullCatalogGenerationScreen = lazy(
  () => import('~/features/item-setup/pages/full-catalog-generation-screen'),
);

export const Route = createFileRoute('/_authenticated/_tenant/item-setup/full-catalog-generation')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <FullCatalogGenerationScreen />
    </Suspense>
  ),
});
